import React from "react";
import { Box, Typography } from "@mui/material";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import useStagger from "../../hooks/useStagger";

const ServiceBusinessCard = ({
    badgeIcon,
    badgeText,
    title,
    description1,
    description2,
    description3,
    image,
    reverse = false,
}) => {
    const [imgRef, imgVisible] = useScrollAnimation(0.1);
    const contentStaggerRef = useStagger({
        delay: 150,
        translateX: reverse ? -45 : 45,
        translateY: 0,
        duration: 1050,
        threshold: 0.08,
        startDelay: 350,
    });

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    lg: reverse ? "1.2fr 0.8fr" : "0.8fr 1.2fr",
                },
                gap: { xs: 5, lg: 8 },
                alignItems: "center",
            }}
        >
            {/* Image */}
            <Box
                ref={imgRef}
                className={`${reverse ? 'anim-fade-right' : 'anim-fade-left'}${imgVisible ? ' in-view' : ''}`}
                sx={{
                    order: {
                        xs: 1,
                        lg: reverse ? 2 : 1,
                    },
                }}
            >
                <Box
                    component="img"
                    src={image}
                    alt={title}
                    sx={{
                        width: "100%",
                        maxWidth: {
                            sx: 'auto',
                            md: '550px'
                        },
                        height: "360px",
                        display: "block",
                        mx: "auto",
                        borderRadius: 2,
                        boxShadow: "0px 20px 40px rgba(34, 24, 58, 0.35)",
                    }}
                />
            </Box>

            {/* Content */}
            <Box
                ref={contentStaggerRef}
                sx={{
                    order: {
                        xs: 2,
                        lg: reverse ? 1 : 2,
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        mb: 3,
                    }}
                >
                    {badgeIcon}

                    <Typography
                        sx={{
                            color: "#fff",
                            fontSize: "1rem",
                            fontWeight: 500,
                        }}
                    >
                        {badgeText}
                    </Typography>
                </Box>

                <Typography
                    sx={{
                        color: "#fff",
                        fontFamily: "var(--font-primary)",
                        fontSize: {
                            xs: "1.8rem",
                            md: "2.2rem",
                        },
                        fontWeight: 600,
                        mb: 3,
                        lineHeight: 1.3,
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    sx={{
                        color: "rgba(255,255,255,0.7)",
                        fontFamily: "var(--font-secondary)",
                        lineHeight: 2,
                        mb: 4,
                    }}
                >
                    {description1}
                </Typography>

                <Typography
                    sx={{
                        color: "rgba(255,255,255,0.7)",
                        fontSize: "19px",
                        lineHeight: 2,
                        mb: description3 ? 4 : 0,
                    }}
                >
                    {description2}
                </Typography>

                {description3 && (
                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.7)",
                            fontSize: "19px",
                            lineHeight: 2,
                        }}
                    >
                        {description3}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default ServiceBusinessCard;
